export default {
    '500': '500 - O servidor encontrou uma situação que não consegue resolver',
    '501': '501 - A sua requisição não possui suporte no servidor',
    '503': '503 - Serviço indisponível'
}